import { Routes } from '@/routes';

export default {
	'assignment.index': () => import('@/modules/assignments/index'),
	'assignment.new': () => import('@/modules/assignments/form'),
	'assignment.new-random': () => import('@/modules/assignments/form-random'),
} as Routes;
